import React, { useState, useEffect } from "react"
import { Slider, makeStyles, withStyles, IconButton } from "@material-ui/core/"
import PauseIcon from "@material-ui/icons/Pause"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import moment from "moment"

const useStyles = makeStyles({
	rootSlider: {
		// margin: "0rem 1rem",
		width: "100%",
		"& .MuiSlider-thumb.Mui-disabled": {
			// color: "#d3d",
			display: "none"
		}
	},
	button: {
		background: "#DDE9FD",
		width: "31px",
		height: "31px",
		borderRadius: "4px",
		padding: "0",
		// margin: "0 0.3rem",
		"&:hover": {
			backgroundColor: "#b7d0fa"
		},
		"&:disabled": {
			backgroundColor: "#d3d3d3"
		}
	}
})

const CustomSlider = withStyles({
	root: {
		display: "flex",
		alignItems: "center"
	},
	thumb: {
		height: 16,
		width: 16,
		border: "2px solid currentColor",
		marginTop: 0
	},
	track: {
		height: 8,
		borderRadius: 4
	},
	rail: {
		height: 8,
		borderRadius: 4,
		display: "flex",
		alignItems: "center"
	},
	mark: {
		height: 4,
		width: 4,
		borderRadius: "50%"
	}
})(Slider)

const AuditSlider = ({
	data,
	allFetchedData,
	handleSliderChange,
	sliderValue,
	setSliderValue,
	playing,
	setPlaying,
	handleStopClick,
	isLoading,
	selectedUser
}) => {
	const classes = useStyles()

	// States
	const [sliderMax, setSliderMax] = useState(100)
	// const [playing, setPlaying] = useState(false)

	// // Logs
	// useEffect(() => {
	// 	// console.log("🚀  sliderValue:", sliderValue)
	// 	// console.log("🚀  data:", JSON.stringify(data))
	// 	console.log("🚀  data slider:", data)
	// 	// console.log("🚀  data moment:", moment(data?.[0]?.date).format("MM/DD/YYYY"))
	// 	// console.log("🚀  allFetchedData slider:", allFetchedData)
	// 	// console.log("🚀  allFetchedData length slider :", allFetchedData.length)
	// }, [sliderValue, data, allFetchedData])

	// Slider max value
	useEffect(() => {
		if (!allFetchedData || allFetchedData.length === 0) return
		setSliderMax(allFetchedData.length - 1)
	}, [allFetchedData])

	// Play slider
	const handlePlayClick = () => {
		setPlaying(!playing)
	}

	// forward button
	const handleForwardMaxClick = e => {
		setSliderValue(sliderMax) // Set the value to the maximum value.
		handleSliderChange(e, sliderMax)
	}

	// forward button 1 step
	const handleBackClick10 = e => {
		const nextValue = Math.max(sliderValue - step, min)
		setSliderValue(nextValue)
		handleSliderChange(e, nextValue)
	}

	// backward button 1 step
	const handleForwardClick10 = e => {
		const nextValue = Math.min(sliderValue + step, sliderMax)
		setSliderValue(nextValue)
		handleSliderChange(e, nextValue)
	}

	// backward button 30 steps
	const handleBackClick30 = e => {
		const nextValue = Math.max(sliderValue - stepSize * step, min)
		setSliderValue(nextValue)
		handleSliderChange(e, nextValue)
	}

	// forward button 30 steps
	const handleForwardClick30 = e => {
		const nextValue = Math.min(sliderValue + stepSize * step, sliderMax)
		setSliderValue(nextValue)
		handleSliderChange(e, nextValue)
	}

	const step = 1 // Steps of the slider
	const min = 0
	const stepSize = 30 // Number of steps to move forward or backward.

	// Playing the slider
	useEffect(() => {
		let interval

		if (playing) {
			interval = setInterval(e => {
				// Increment the value by the step size until it reaches the maximum.
				if (sliderValue < sliderMax) {
					setSliderValue(sliderValue + step)
					handleSliderChange(e, sliderValue + step) // onChange slider to filter data
				} else {
					// Stop playing when the maximum value is reached.
					setPlaying(false)
				}
			}, 800) // ----------------> Adjust the interval timing as needed.
		} else {
			clearInterval(interval)
		}

		return () => {
			clearInterval(interval)
		}
	}, [playing, sliderValue])

	// function valueText(value) {
	// 	// console.log("🚀  value:", value)
	// 	return `${value}`
	// }

	const sliderDisableCondition = isLoading
		? true
		: data.length === 0
		? true
		: !selectedUser
		? true
		: false

	// Icons to buttons
	const playPauseSvg = playing ? (
		<PauseIcon style={{ color: "#2673F0" }} />
	) : (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="17"
			viewBox="0 0 17 17"
			fill="none"
		>
			<path
				d="M4.14062 14.3125C4.01216 14.3125 3.88896 14.2614 3.79812 14.1706C3.70728 14.0798 3.65625 13.9566 3.65625 13.8281V3.17185C3.65624 3.08767 3.67817 3.00495 3.71988 2.93183C3.76158 2.85871 3.82162 2.79773 3.89408 2.75488C3.96653 2.71204 4.0489 2.68881 4.13307 2.6875C4.21723 2.68618 4.30029 2.70683 4.37405 2.74739L14.0615 8.07552C14.1375 8.11731 14.2009 8.17875 14.2451 8.25341C14.2892 8.32807 14.3125 8.41321 14.3125 8.49995C14.3125 8.58669 14.2892 8.67183 14.2451 8.74649C14.2009 8.82115 14.1375 8.88259 14.0615 8.92438L4.37405 14.2525C4.30253 14.2918 4.22224 14.3125 4.14062 14.3125Z"
				fill={allFetchedData.length === 0 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>{" "}
		</svg>
	)

	const back30Icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M2 9C2 10.1867 2.35189 11.3467 3.01118 12.3334C3.67047 13.3201 4.60754 14.0892 5.7039 14.5433C6.80026 14.9974 8.00666 15.1162 9.17054 14.8847C10.3344 14.6532 11.4035 14.0818 12.2426 13.2426C13.0818 12.4035 13.6532 11.3344 13.8847 10.1705C14.1162 9.00666 13.9974 7.80026 13.5433 6.7039C13.0892 5.60754 12.3201 4.67047 11.3334 4.01118C10.3467 3.35189 9.18669 3 8 3H6V0.5L3 3.5L6 6.5V4H8C8.98891 4 9.95561 4.29324 10.7779 4.84265C11.6001 5.39206 12.241 6.17295 12.6194 7.08658C12.9978 8.00021 13.0969 9.00555 12.9039 9.97545C12.711 10.9454 12.2348 11.8363 11.5355 12.5355C10.8363 13.2348 9.94536 13.711 8.97545 13.9039C8.00555 14.0969 7.00021 13.9978 6.08658 13.6194C5.17295 13.241 4.39206 12.6001 3.84265 11.7779C3.29324 10.9556 3 9.98891 3 9H2ZM9.82001 11.0651C9.59902 11.071 9.37975 11.0248 9.18001 10.9301C9.00154 10.8414 8.84845 10.7089 8.73501 10.5451C8.61601 10.3544 8.53612 10.1419 8.50001 9.92007C8.43845 9.64443 8.40992 9.36245 8.41501 9.08007C8.41048 8.79771 8.43901 8.51579 8.50001 8.24007C8.54467 8.01665 8.63303 7.80425 8.76001 7.61507C8.87345 7.45122 9.02654 7.31877 9.20501 7.23007C9.40475 7.13535 9.62402 7.08909 9.84501 7.09507C10.0527 7.07926 10.2611 7.11692 10.4501 7.20444C10.6392 7.29197 10.8027 7.42645 10.925 7.59507C11.1807 8.03938 11.3022 8.54819 11.275 9.06007C11.3022 9.57195 11.1807 10.0808 10.925 10.5251C10.8051 10.7049 10.6397 10.8496 10.4455 10.9445C10.2514 11.0394 10.0355 11.081 9.82001 11.0651ZM9.82001 10.4551C9.92145 10.4657 10.0237 10.4451 10.1131 10.3959C10.2025 10.3467 10.2747 10.2714 10.32 10.1801C10.4299 9.94411 10.4814 9.68513 10.47 9.42507V8.73507C10.482 8.47657 10.4305 8.21908 10.32 7.98507C10.2647 7.89941 10.1888 7.82898 10.0993 7.78021C10.0098 7.73144 9.90946 7.70589 9.80751 7.70589C9.70556 7.70589 9.60523 7.73144 9.5157 7.78021C9.42617 7.82898 9.3503 7.89941 9.29501 7.98507C9.18644 8.21957 9.13667 8.477 9.15001 8.73507V9.42507C9.13725 9.68471 9.18698 9.94362 9.29501 10.1801C9.34176 10.2759 9.41792 10.3543 9.51237 10.4037C9.60682 10.4532 9.71461 10.4712 9.82001 10.4551ZM6.81 8.57508C6.66543 8.67967 6.48756 8.7277 6.31 8.71008H5.94V9.31507H6.32C6.507 9.30482 6.69246 9.35381 6.85 9.45508C6.90935 9.50318 6.95688 9.56425 6.98895 9.63359C7.02102 9.70293 7.03677 9.7787 7.035 9.85507V9.89508C7.0382 9.97389 7.0247 10.0525 6.99541 10.1257C6.96611 10.199 6.92167 10.2652 6.865 10.3201C6.72274 10.4304 6.54451 10.4839 6.365 10.4701C6.26881 10.4722 6.17282 10.4604 6.08 10.4351C5.9996 10.4107 5.92363 10.3735 5.855 10.3251C5.78798 10.2763 5.72749 10.2192 5.675 10.1551C5.62265 10.089 5.57582 10.0188 5.535 9.94508L5 10.3501C5.06554 10.4477 5.13913 10.5397 5.22 10.6251C5.30313 10.712 5.39726 10.7876 5.5 10.8501C5.61924 10.9184 5.74702 10.9705 5.88 11.0051C6.04378 11.0439 6.21171 11.0623 6.38 11.0601C6.57465 11.0633 6.76863 11.0364 6.955 10.9801C7.11619 10.9338 7.26718 10.8575 7.4 10.7551C7.52346 10.6594 7.62278 10.5361 7.69 10.3951C7.75946 10.2519 7.79375 10.0942 7.79 9.93508C7.79208 9.81079 7.77176 9.68715 7.73 9.57008C7.68955 9.46932 7.63204 9.3763 7.56 9.29508C7.48771 9.21626 7.4012 9.1518 7.305 9.10507C7.20553 9.05528 7.09946 9.01992 6.99 9.00008V8.97008C7.08903 8.94959 7.18488 8.91596 7.275 8.87008C7.36278 8.82353 7.4422 8.7627 7.51 8.69007C7.57759 8.61304 7.63169 8.52513 7.67 8.43008C7.70729 8.32236 7.72589 8.20906 7.725 8.09508C7.72723 7.95167 7.69643 7.80967 7.635 7.68007C7.56917 7.55656 7.477 7.44902 7.365 7.36507C7.24285 7.27204 7.10351 7.20407 6.955 7.16507C6.78233 7.11777 6.60403 7.09422 6.425 7.09507C6.27841 7.09204 6.13208 7.10886 5.99 7.14507C5.86732 7.17257 5.74937 7.21806 5.64 7.28008C5.54202 7.33524 5.45132 7.40242 5.37 7.48007C5.2914 7.56039 5.21793 7.64556 5.15 7.73507L5.615 8.15007C5.70051 8.01197 5.81689 7.89558 5.955 7.81007C6.08892 7.72861 6.24328 7.68699 6.4 7.69007C6.55037 7.68139 6.69852 7.72958 6.815 7.82507C6.86563 7.87196 6.90532 7.92941 6.93124 7.99336C6.95716 8.0573 6.96869 8.12617 6.965 8.19507V8.23507C6.96716 8.29987 6.95428 8.36428 6.92739 8.42326C6.9005 8.48225 6.86032 8.53421 6.81 8.57508Z"
				fill={allFetchedData.length < 30 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>
		</svg>
	)

	const back10Icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="17"
			viewBox="0 0 17 17"
			fill="none"
		>
			<path
				d="M2.6875 9.46875C2.6875 10.6184 3.0284 11.7421 3.66708 12.698C4.30577 13.6539 5.21356 14.3989 6.27565 14.8388C7.33775 15.2787 8.50645 15.3938 9.63396 15.1696C10.7615 14.9453 11.7972 14.3917 12.6101 13.5788C13.423 12.7659 13.9765 11.7302 14.2008 10.6027C14.4251 9.4752 14.31 8.3065 13.87 7.2444C13.4301 6.18231 12.6851 5.27452 11.7293 4.63583C10.7734 3.99715 9.6496 3.65625 8.5 3.65625H6.5625V1.23438L3.65625 4.14062L6.5625 7.04688V4.625H8.5C9.458 4.625 10.3945 4.90908 11.191 5.44132C11.9876 5.97356 12.6084 6.73005 12.975 7.61513C13.3417 8.50021 13.4376 9.47412 13.2507 10.4137C13.0638 11.3533 12.6025 12.2164 11.925 12.8938C11.2476 13.5712 10.3846 14.0325 9.44497 14.2194C8.50537 14.4063 7.53146 14.3104 6.64638 13.9438C5.7613 13.5772 5.00481 12.9563 4.47257 12.1598C3.94033 11.3632 3.65625 10.4268 3.65625 9.46875H2.6875ZM10.2583 11.4693C10.0443 11.4745 9.83196 11.4298 9.63828 11.3385C9.46631 11.2512 9.31831 11.1232 9.20719 10.9655C9.08538 10.7816 8.99989 10.5761 8.95532 10.3601C8.89808 10.0927 8.87047 9.81977 8.87297 9.54632C8.87101 9.27289 8.89861 9.00006 8.95532 8.73257C9.00078 8.5168 9.08621 8.31145 9.20719 8.1271C9.31831 7.96946 9.46631 7.84142 9.63828 7.75413C9.83196 7.66288 10.0443 7.6181 10.2583 7.62335C10.4595 7.60804 10.6613 7.64452 10.8445 7.7293C11.0276 7.8141 11.186 7.94437 11.3045 8.10772C11.5543 8.5373 11.6722 9.03085 11.6436 9.52694C11.6722 10.023 11.5543 10.5166 11.3045 10.9462C11.1905 11.1166 11.0341 11.2545 10.8507 11.3462C10.6672 11.438 10.4631 11.4804 10.2583 11.4693ZM10.2583 10.8783C10.3559 10.8842 10.4532 10.8623 10.539 10.8151C10.6247 10.768 10.6953 10.6975 10.7427 10.6119C10.8584 10.3854 10.9198 10.135 10.9219 9.88054V9.2121C10.9324 8.96227 10.8842 8.71346 10.7814 8.48554C10.7273 8.40258 10.6533 8.33444 10.5662 8.28727C10.4791 8.24011 10.3816 8.2154 10.2825 8.2154C10.1834 8.2154 10.0859 8.24011 9.99883 8.28727C9.91172 8.33444 9.83774 8.40258 9.7836 8.48554C9.68076 8.71346 9.63265 8.96227 9.64313 9.2121V9.88054C9.63314 10.1319 9.68121 10.3822 9.7836 10.6119C9.8298 10.6964 9.8988 10.7661 9.98273 10.8132C10.0667 10.8603 10.1621 10.8829 10.2583 10.8783ZM5.89891 10.8347V11.4063H8.39344V10.8105H7.53125V7.66204H6.82406L5.70031 8.29173L5.96672 8.80517L6.86766 8.32079V10.8347H5.89891Z"
				fill={allFetchedData.length === 0 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>
		</svg>
	)

	const backIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="17"
			viewBox="0 0 17 17"
			fill="none"
		>
			<path
				d="M1.71875 2.6875H2.6875V14.3125H1.71875V2.6875ZM13.5855 14.2471C13.6592 14.2899 13.7429 14.3124 13.8281 14.3124C13.9566 14.3124 14.0798 14.2614 14.1706 14.1706C14.2615 14.0797 14.3125 13.9565 14.3125 13.828V3.1718C14.3124 3.08675 14.29 3.00322 14.2474 2.9296C14.2048 2.85598 14.1436 2.79487 14.0699 2.75241C13.9962 2.70996 13.9127 2.68765 13.8276 2.68774C13.7426 2.68782 13.6591 2.7103 13.5855 2.75291L4.38233 8.08104C4.30893 8.12362 4.248 8.18473 4.20565 8.25826C4.16329 8.3318 4.141 8.41516 4.141 8.50002C4.141 8.58488 4.16329 8.66825 4.20565 8.74178C4.248 8.81531 4.30893 8.87643 4.38233 8.91901L13.5855 14.2471Z"
				fill={allFetchedData.length === 0 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>
		</svg>
	)

	const forwardIcon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M13.5625 1.9375H14.5312V13.5625H13.5625V1.9375ZM2.07937 13.4207C2.17021 13.5116 2.29341 13.5626 2.42188 13.5626C2.50713 13.5626 2.59085 13.54 2.66455 13.4971L11.8677 8.169C11.9411 8.12643 12.002 8.06531 12.0444 7.99178C12.0867 7.91825 12.109 7.83488 12.109 7.75002C12.109 7.66516 12.0867 7.58179 12.0444 7.50826C12.002 7.43473 11.9411 7.37361 11.8677 7.33104L2.66455 2.00291C2.59093 1.96029 2.50739 1.93782 2.42232 1.93774C2.33726 1.93766 2.25368 1.95998 2.17998 2.00246C2.10629 2.04494 2.04508 2.10608 2.00251 2.17973C1.95994 2.25337 1.93752 2.33693 1.9375 2.42199V13.0782C1.9375 13.2067 1.98853 13.3299 2.07937 13.4207Z"
				fill={allFetchedData.length === 0 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>
		</svg>
	)

	const forward10Icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
		>
			<path
				d="M13 9C13 9.98891 12.7068 10.9556 12.1574 11.7779C11.6079 12.6001 10.8271 13.241 9.91342 13.6194C8.99979 13.9978 7.99446 14.0969 7.02455 13.9039C6.05465 13.711 5.16373 13.2348 4.46447 12.5355C3.76521 11.8363 3.289 10.9454 3.09608 9.97545C2.90315 9.00555 3.00217 8.00021 3.38061 7.08658C3.75904 6.17295 4.39991 5.39206 5.22215 4.84265C6.0444 4.29324 7.0111 4 8 4H10V6.5L13 3.5L10 0.5V3H8C6.81331 3 5.65328 3.35189 4.66658 4.01118C3.67989 4.67047 2.91085 5.60754 2.45673 6.7039C2.0026 7.80026 1.88378 9.00666 2.11529 10.1705C2.3468 11.3344 2.91825 12.4035 3.75736 13.2426C4.59648 14.0818 5.66558 14.6532 6.82946 14.8847C7.99335 15.1162 9.19975 14.9974 10.2961 14.5433C11.3925 14.0892 12.3295 13.3201 12.9888 12.3334C13.6481 11.3467 14 10.1867 14 9H13ZM9.81501 11.0649C9.59407 11.0704 9.37493 11.0241 9.17501 10.9299C8.99748 10.8398 8.84471 10.7077 8.73001 10.5449C8.60427 10.3551 8.51602 10.143 8.47001 9.91995C8.41093 9.64392 8.38242 9.36222 8.38501 9.07995C8.38298 8.7977 8.41148 8.51606 8.47001 8.23995C8.51694 8.01722 8.60512 7.80524 8.73001 7.61495C8.84471 7.45223 8.99748 7.32005 9.17501 7.22995C9.37493 7.13576 9.59407 7.08953 9.81501 7.09495C10.0227 7.07914 10.2311 7.1168 10.4201 7.20432C10.6092 7.29185 10.7727 7.42633 10.895 7.59495C11.1528 8.03838 11.2745 8.54786 11.245 9.05995C11.2745 9.57204 11.1528 10.0815 10.895 10.5249C10.7773 10.7009 10.6159 10.8432 10.4265 10.9379C10.2371 11.0326 10.0264 11.0764 9.81501 11.0649ZM9.81501 10.4549C9.91581 10.461 10.0163 10.4383 10.1047 10.3897C10.1932 10.341 10.2661 10.2683 10.315 10.1799C10.4345 9.94607 10.4978 9.68757 10.5 9.42495V8.73495C10.5108 8.47706 10.4612 8.22022 10.355 7.98495C10.2991 7.89932 10.2228 7.82898 10.1328 7.78029C10.0429 7.7316 9.94226 7.7061 9.84001 7.7061C9.73775 7.7061 9.63711 7.7316 9.54718 7.78029C9.45726 7.82898 9.3809 7.89932 9.32501 7.98495C9.21885 8.22022 9.16919 8.47706 9.18001 8.73495V9.42495C9.1697 9.68441 9.21931 9.94276 9.32501 10.1799C9.3727 10.2671 9.44393 10.3391 9.53056 10.3877C9.6172 10.4363 9.71577 10.4596 9.81501 10.4549ZM5.315 10.41V11H7.89V10.385H7V7.13501H6.27L5.11 7.78501L5.385 8.31501L6.315 7.81501V10.41H5.315Z"
				fill={allFetchedData.length === 0 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>
		</svg>
	)

	const forward30Icon = (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="17"
			viewBox="0 0 17 17"
			fill="none"
		>
			<path
				d="M13.3438 9.46875C13.3438 10.4268 13.0597 11.3632 12.5274 12.1598C11.9952 12.9563 11.2387 13.5772 10.3536 13.9438C9.46855 14.3104 8.49463 14.4063 7.55503 14.2194C6.61544 14.0325 5.75236 13.5712 5.07495 12.8938C4.39754 12.2164 3.93622 11.3533 3.74932 10.4137C3.56243 9.47412 3.65835 8.50021 4.02496 7.61513C4.39157 6.73005 5.01241 5.97356 5.80896 5.44132C6.60551 4.90908 7.542 4.625 8.5 4.625H10.4375V7.04688L13.3438 4.14062L10.4375 1.23438V3.65625H8.5C7.3504 3.65625 6.22661 3.99715 5.27075 4.63583C4.31489 5.27452 3.56989 6.18231 3.12995 7.2444C2.69002 8.3065 2.57491 9.4752 2.79919 10.6027C3.02346 11.7302 3.57705 12.7659 4.38994 13.5788C5.20284 14.3917 6.23853 14.9453 7.36604 15.1696C8.49356 15.3938 9.66225 15.2787 10.7243 14.8388C11.7864 14.3989 12.6942 13.6539 13.3329 12.698C13.9716 11.7421 14.3125 10.6184 14.3125 9.46875H13.3438ZM10.2631 11.4692C10.049 11.475 9.83663 11.4301 9.64313 11.3384C9.47024 11.2525 9.32193 11.1241 9.21203 10.9654C9.09675 10.7807 9.01937 10.5749 8.98438 10.3599C8.92475 10.0929 8.8971 9.81975 8.90203 9.5462C8.89765 9.27267 8.92528 8.99956 8.98438 8.73245C9.02765 8.51601 9.11324 8.31025 9.23625 8.12698C9.34615 7.96825 9.49446 7.83994 9.66735 7.75401C9.86085 7.66225 10.0733 7.61744 10.2873 7.62323C10.4886 7.60792 10.6904 7.6444 10.8735 7.72919C11.0567 7.81398 11.2151 7.94425 11.3336 8.1076C11.5813 8.53803 11.699 9.03094 11.6727 9.52682C11.699 10.0227 11.5813 10.5156 11.3336 10.946C11.2175 11.1202 11.0572 11.2605 10.8691 11.3524C10.681 11.4443 10.4719 11.4846 10.2631 11.4692ZM10.2631 10.8782C10.3614 10.8885 10.4605 10.8685 10.5471 10.8209C10.6336 10.7733 10.7036 10.7003 10.7475 10.6118C10.854 10.3832 10.9038 10.1324 10.8928 9.88042V9.21198C10.9044 8.96156 10.8545 8.71211 10.7475 8.48542C10.6939 8.40244 10.6204 8.33421 10.5337 8.28696C10.447 8.23972 10.3498 8.21496 10.251 8.21496C10.1523 8.21496 10.0551 8.23972 9.96833 8.28696C9.8816 8.33421 9.8081 8.40244 9.75453 8.48542C9.64936 8.71259 9.60115 8.96198 9.61406 9.21198V9.88042C9.60171 10.1319 9.64988 10.3828 9.75453 10.6118C9.79982 10.7047 9.87361 10.7806 9.9651 10.8285C10.0566 10.8764 10.161 10.8939 10.2631 10.8782ZM7.34719 9.05699C7.20714 9.15831 7.03483 9.20484 6.86281 9.18777H6.50438V9.77386H6.8725C7.05365 9.76392 7.23333 9.81138 7.38594 9.90949C7.44343 9.95609 7.48948 10.0153 7.52055 10.0824C7.55161 10.1496 7.56687 10.223 7.56516 10.297V10.3357C7.56825 10.4121 7.55518 10.4882 7.5268 10.5592C7.49842 10.6301 7.45537 10.6943 7.40047 10.7475C7.26266 10.8544 7.09 10.9062 6.9161 10.8928C6.82291 10.8948 6.72992 10.8834 6.64 10.8589C6.56211 10.8352 6.48852 10.7993 6.42203 10.7523C6.35711 10.7051 6.29851 10.6497 6.24766 10.5876C6.19694 10.5236 6.15158 10.4556 6.11203 10.3842L5.59375 10.7765C5.65725 10.8711 5.72854 10.9602 5.80688 11.0429C5.88741 11.1271 5.9786 11.2004 6.07813 11.2609C6.19364 11.327 6.31743 11.3775 6.44625 11.411C6.60491 11.4486 6.76759 11.4665 6.93063 11.4643C7.1192 11.4675 7.30711 11.4413 7.48766 11.3868C7.64381 11.342 7.79008 11.268 7.91875 11.1689C8.03835 11.0761 8.13457 10.9567 8.19969 10.8201C8.26698 10.6814 8.30019 10.5286 8.29656 10.3745C8.29858 10.2541 8.27889 10.1343 8.23844 10.0209C8.19925 9.92329 8.14354 9.83317 8.07375 9.75449C8.00372 9.67814 7.91991 9.61569 7.82672 9.57042C7.73035 9.52218 7.6276 9.48793 7.52156 9.4687V9.43964C7.6175 9.4198 7.71035 9.38721 7.79766 9.34277C7.8827 9.29768 7.95963 9.23875 8.02531 9.16839C8.0908 9.09376 8.1432 9.00861 8.18031 8.91652C8.21644 8.81217 8.23446 8.70241 8.2336 8.59199C8.23575 8.45306 8.20592 8.3155 8.14641 8.18995C8.08264 8.0703 7.99334 7.96612 7.88485 7.8848C7.76651 7.79467 7.63153 7.72883 7.48766 7.69105C7.32039 7.64522 7.14765 7.6224 6.97422 7.62324C6.83221 7.6203 6.69045 7.63659 6.55281 7.67167C6.43396 7.69831 6.31971 7.74238 6.21375 7.80245C6.11884 7.85589 6.03097 7.92098 5.95219 7.9962C5.87605 8.07401 5.80487 8.15651 5.73906 8.24324L6.18953 8.64527C6.27237 8.51148 6.38512 8.39873 6.51891 8.31589C6.64864 8.23697 6.79818 8.19665 6.95 8.19964C7.09568 8.19123 7.23919 8.23791 7.35203 8.33042C7.40108 8.37584 7.43953 8.4315 7.46464 8.49345C7.48975 8.55539 7.50092 8.62211 7.49735 8.68886V8.72761C7.49943 8.79038 7.48696 8.85277 7.46091 8.90992C7.43486 8.96706 7.39594 9.0174 7.34719 9.05699Z"
				fill={allFetchedData.length < 30 || sliderDisableCondition ? "#a4a4a4" : "#2673F0"}
			/>
		</svg>
	)

	const formattedDate =
		data && data.length !== 0 && data?.[0]?.date
			? moment(data?.[0]?.date).format("MM/DD/YYYY")
			: "00/00/0000"

	var dateTimeString = data && data.length !== 0 && data?.[0]?.date

	// Separate the time from the date manually
	var parts = dateTimeString && dateTimeString.split(" ")
	var timePart = parts && parts?.[4] && parts[4]

	// Convert the time to a 12-hour format with AM/PM
	var timeArray = timePart && timePart.split(":")
	var hours = timeArray && parseInt(timeArray[0], 10)
	var minutes = timeArray && timeArray[1]
	var seconds = timeArray && timeArray[2]

	var ampm = hours && hours >= 12 ? "PM" : "AM"
	hours = hours % 12
	hours = hours ? hours : 12 // "0" hour should be displayed as "12"

	var formattedTime =
		data && data.length !== 0 && hours && minutes && seconds && ampm
			? hours + ":" + minutes + ":" + seconds + " " + ampm
			: "00:00:00 AM"

	return (
		<div data-testid="main-div-AuditSlider">
			<div style={{ padding: "0px", margin: "1rem 0rem 1rem 0rem" }}>
				<div className={classes.rootSlider}>
					<CustomSlider
						id="slider_audit_tool"
						defaultValue={0}
						value={sliderValue}
						// getAriaValueText={valueText}
						onChange={(e, newValue) => handleSliderChange(e, newValue)}
						// valueLabelDisplay="auto" // label on top
						step={1}
						// marks
						min={min}
						// max={sliderMax}
						max={allFetchedData.length - 1 || 100}
						disabled={sliderDisableCondition}
					/>
				</div>
			</div>

			<div className="row m-0 mb-6">
				<div className="col-12 col-xl-6 col-lg-12 col-md-12 pl-0 pr-0 d-flex justify-content-center justify-content-xl-start justify-content-lg-center">
					<div className="row">
						<div className="col-12 col-xl-6 pr-xl-0 ">
							<div className="audit_tool_date_box">
								<span className="audit_tool_date_box_text">Current Day</span>
								<span className="audit_tool_date_box_number">{formattedDate}</span>
							</div>
						</div>
						<div className="col-12 col-xl-6 mt-3 mt-xl-0">
							<div className="audit_tool_date_box">
								<span className="audit_tool_date_box_text">Current Time</span>
								<span className="audit_tool_date_box_number">
									{formattedTime && formattedTime}
								</span>
							</div>
						</div>
					</div>
				</div>
				<div className="col-12 col-xl-6 col-lg-12 col-md-12 pr-0 mt-6 mt-xl-0 mt-xl-0 d-flex justify-content-center justify-content-xl-end justify-content-lg-center">
					<div className="mr-2">
						<OverlayTrigger placement="top" overlay={<Tooltip>Back 30 steps</Tooltip>}>
							<IconButton
								className={classes.button}
								onClick={e => {
									handleBackClick30(e)
								}}
								disabled={allFetchedData.length < 30 || sliderDisableCondition}
								data-testid="handleBackClick30-button"
							>
								{back30Icon}
							</IconButton>
						</OverlayTrigger>
					</div>
					<div className="mr-2">
						<OverlayTrigger placement="top" overlay={<Tooltip>Back 1 step</Tooltip>}>
							<IconButton
								id="back_1_step_audit_tool"
								className={classes.button}
								onClick={e => {
									handleBackClick10(e)
								}}
								disabled={allFetchedData.length === 0 || sliderDisableCondition}
								data-testid="handleBackClick10-button"
							>
								{back10Icon}
							</IconButton>
						</OverlayTrigger>
					</div>
					<div className="mr-2">
						<OverlayTrigger placement="top" overlay={<Tooltip>Back to start</Tooltip>}>
							<IconButton
								id="backward_start_step_audit_tool"
								className={classes.button}
								onClick={e => handleStopClick(e)}
								disabled={allFetchedData.length === 0 || sliderDisableCondition}
								data-testid="handleStopClick-button"
							>
								{backIcon}
							</IconButton>
						</OverlayTrigger>
					</div>
					<div className="mr-2">
						<OverlayTrigger
							placement="top"
							overlay={<Tooltip>{playing ? "Pause" : "Play"}</Tooltip>}
						>
							<IconButton
								id={playing ? "pause_step_audit_tool" : "play_step_audit_tool"}
								className={classes.button}
								onClick={handlePlayClick}
								disabled={allFetchedData.length === 0 || sliderDisableCondition}
								data-testid="handlePlayClick-button"
							>
								{playPauseSvg}
							</IconButton>
						</OverlayTrigger>
					</div>
					<div className="mr-2">
						<OverlayTrigger placement="top" overlay={<Tooltip>Forward to end</Tooltip>}>
							<IconButton
								id="forward_end_step_audit_tool"
								className={classes.button}
								onClick={e => handleForwardMaxClick(e)}
								disabled={allFetchedData.length === 0 || sliderDisableCondition}
								data-testid="handleForwardMaxClick-button"
							>
								{forwardIcon}
							</IconButton>
						</OverlayTrigger>
					</div>

					<div className="mr-2">
						<OverlayTrigger placement="top" overlay={<Tooltip>Forward 1 step</Tooltip>}>
							<IconButton
								id="forward_1_step_audit_tool"
								className={classes.button}
								onClick={e => {
									handleForwardClick10(e)
								}}
								disabled={allFetchedData.length === 0 || sliderDisableCondition}
								data-testid="handleForwardClick10-button"
							>
								{forward10Icon}
							</IconButton>
						</OverlayTrigger>
					</div>

					<div>
						<OverlayTrigger placement="top" overlay={<Tooltip>Forward 30 steps</Tooltip>}>
							<IconButton
								id="forward_30_step_audit_tool"
								className={classes.button}
								onClick={e => {
									handleForwardClick30(e)
								}}
								disabled={allFetchedData.length < 30 || sliderDisableCondition}
								data-testid="handleForwardClick30-button"
							>
								{forward30Icon}
							</IconButton>
						</OverlayTrigger>
					</div>
				</div>
			</div>
		</div>
	)
}

export default AuditSlider
